/*******************************************************************************
Remove Button Processing State
Removes the processing state from a button.
*******************************************************************************/

export default function removeButtonProcessingState($button) {

    // Grab the original button html from the data attribute
    const origButtonHTML = $button.data('origbuttonhtml');

    // Reset the button text
    $button.safehtml(origButtonHTML);

    // Remove the hover state (if necessary)
    $button.removeClass('hovering');

    // Enable the button
    $button.prop('disabled', false);

}
